import { UserRole } from '../types';
import { dualRoutePath } from './workbenchRoutes';

export const BUYER_WORKBENCH_ROLES = [
  UserRole.BUYER,
  UserRole.WAREHOUSE,
  UserRole.CENTRAL_PURCHASER,
];

export const APPROVAL_WORKBENCH_ROLES = [
  UserRole.APPROVER,
  UserRole.PROJECT_MANAGER,
  UserRole.REGIONAL_MANAGER,
  UserRole.ADMIN,
  UserRole.PURCHASE_MANAGER,
  UserRole.CENTRAL_PURCHASER,
  UserRole.DEPUTY_GENERAL_MANAGER,
  UserRole.GENERAL_MANAGER,
  UserRole.APPROVAL_LEADER,
  UserRole.FINANCE,
];

export const PLATFORM_WORKBENCH_ROLES = [UserRole.ADMIN, UserRole.PLATFORM_ADMIN];

/** 严选运营工作台（商品/订单/需求等运维侧，不含普通直采供应商） */
export const YANXUAN_OPS_WORKBENCH_ROLES = [
  UserRole.YANXUAN_ADMIN,
  UserRole.ADMIN,
  UserRole.PLATFORM_ADMIN,
];

/** 联采严选工作台路由：运营侧 + 指定严选供应商 */
export const YANXUAN_WORKBENCH_ROLES = [
  ...YANXUAN_OPS_WORKBENCH_ROLES,
  UserRole.SUPPLIER,
];

/** 企业管理中心及子功能：仅企业管理员 */
export const SETTINGS_COMPANY_ROLES = [UserRole.COMPANY_ADMIN];

export const SETTINGS_USERS_ROLES = [UserRole.COMPANY_ADMIN];

export const SETTINGS_WORKFLOW_ROLES = [UserRole.COMPANY_ADMIN];

export function canAccessCompanyCenter(role?: string | null): boolean {
  return role === UserRole.COMPANY_ADMIN;
}

export function resolveDefaultRouteByRole(
  role: UserRole | string | undefined,
  preferMobileLayout: boolean,
): string {
  if (!role) return '/';

  if (role === UserRole.COMPANY_ADMIN) {
    return dualRoutePath('settingsCompany', preferMobileLayout);
  }

  if (role === UserRole.BUYER || role === UserRole.WAREHOUSE) {
    return dualRoutePath('buyer', preferMobileLayout);
  }
  if (role === UserRole.CENTRAL_PURCHASER) {
    return dualRoutePath('centralProcurement', preferMobileLayout);
  }

  if (role === UserRole.ADMIN || role === UserRole.PLATFORM_ADMIN) {
    return dualRoutePath('platform', preferMobileLayout);
  }

  if (role === UserRole.YANXUAN_ADMIN) {
    return '/yanxuan';
  }

  if (APPROVAL_WORKBENCH_ROLES.includes(role as UserRole)) {
    return dualRoutePath('approval', preferMobileLayout);
  }

  if (role === UserRole.SUPPLIER) {
    return dualRoutePath('supplier', preferMobileLayout);
  }

  return '/home';
}
